import script from "./UltimasNoticiasNew.vue?vue&type=script&setup=true&lang=js"
export * from "./UltimasNoticiasNew.vue?vue&type=script&setup=true&lang=js"

import "./UltimasNoticiasNew.vue?vue&type=style&index=0&id=56cd7832&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56cd7832"]])

export default __exports__